import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FolderOpen } from "lucide-react";
import FamilleArticlesTab from "@features/creation/famille-articles/components/FamilleArticlesTab";

export const Route = createFileRoute('/_app/creation/familleArticles/')({
  loader: requirePermission(PERMISSIONS.CREATION.FAMILLE_ARTICLES.VIEW),
  staticData: {
    title: "Familles Articles",
    icon: FolderOpen,
    permission: PERMISSIONS.CREATION.FAMILLE_ARTICLES.VIEW,
    module: "creation",
    section: "Creation",
    order: 23,
    description: "Gestion des familles d'articles",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: FamilleArticlesTab,
});
